import { atom } from 'recoil';
import useGetLocalStorageLanguage from '../../hooks/useGetLocalStorageLanguage';

let selectedLanguage = useGetLocalStorageLanguage();
export const languageState = atom({
  key: 'languageState',
  default: selectedLanguage, // 기본 언어 설정
});
